import { inject, InjectionToken } from '@angular/core';
import { distinctUntilChanged, filter, map, shareReplay } from 'rxjs/operators';
import { PartnerService } from '@galaxy/partner';
import { ConfigManagerConfig } from '@vendasta/config-manager';

export const CONFIG_MANAGER_CONFIG = new InjectionToken<ConfigManagerConfig>(
  '[ConfigManager]: token for configuration',
  {
    providedIn: 'root',
    factory: () => {
      const partnerService = inject(PartnerService);

      const partnerId$ = partnerService.getPartnerId().pipe(
        map((partnerId) => partnerId),
        filter<string>(Boolean),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      return {
        partnerId$,
      };
    },
  },
);
